import { onlineManager } from '@tanstack/react-query';
import { useSyncExternalStore } from 'react';

/** Online state, shared with TanStack Query's `onlineManager` (so tests can toggle it). */
export function useOnline(): boolean {
  return useSyncExternalStore(
    (cb) => onlineManager.subscribe(cb),
    () => onlineManager.isOnline(),
    () => true,
  );
}
